module.exports = __webpack_public_path__ + "static/media/cacBeverage.35381d32.jpg";